import React from "react";
import { APP_ROUTES } from "../../../constants";
import { AppRouteMenuModel } from "../../../models";
import { DescriptionOutlined as DescriptionOutlinedIcon } from "@material-ui/icons";

import { BlogListing } from "../";

export const ContentRoutes: AppRouteMenuModel[] = [
  {
    // blog
    path: APP_ROUTES.BLOG.BASE,
    title: "Pages",
    renderComponent: () => {
      return <BlogListing />;
    },
    icons: {
      inactive: <DescriptionOutlinedIcon style={{ color: "#525560", fontSize: "2.2rem" }} />,
      active: <DescriptionOutlinedIcon style={{ color: "#fff", fontSize: "2.2rem" }} />,
    },
  }
];
